import Vue from 'vue'
import Router from 'vue-router'

import Login from '../components/Login'
import Logout from '../components/Logout'
import Giftcode from '../components/Giftcode'
import ChangePassword from '../components/ChangePassword'
import ChangeEmail from '../components/ChangeEmail'
import ResetPassword from '../components/ResetPassword'
import Register from '../components/Register'
import Account from '../components/Account'
import DailyGift from '../components/DailyGift'
import Card from '../components/Card'
import IPBonus from '../components/IPBonus'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login
        },
        {
            path: '/dang-nhap',
            name: 'Login',
            component: Login
        },
        {
            path: '/logout',
            name: 'Logout',
            component: Logout
        },
        {
            path: '/giftcode',
            name: 'Giftcode',
            component: Giftcode
        },
        {
            path: '/doi-mat-khau',
            name: 'ChangePassword',
            component: ChangePassword
        },
        {
            path: '/change-email',
            name: 'ChangeEmail',
            component: ChangeEmail
        },
        {
            path: '/reset-password',
            name: 'ResetPassword',
            component: ResetPassword
        },
        {
            path: '/qua-tang-hang-ngay',
            name: 'DailyGift',
            component: DailyGift
        },
        {
            path: '/dang-ky',
            name: 'Register',
            component: Register
        },
        {
            path: '/register/:account',
            name: 'RegisterWithRef',
            component: Register
        },
        {
            path: '/thong-tin-tai-khoan',
            name: 'Account',
            component: Account
        },
        {
            path: '/nap-the',
            name: 'Card',
            component: Card
        },
        {
            path: '/ip-bonus',
            name: 'IPBonus',
            component: IPBonus
        },
    ]
})